import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { InventorySliceState, IItemSubCategory } from "../../utils/inventory.types";
import { ApiStatus } from "../../utils/api.types";
import { addInventory, deleteInventory, fetchInventories, updateInventory, fetchInventoryById, fetchInventoryByAccountId, AdjustStockBySkuId,  fetchItemCategories, createItemCategory, updateItemCategory, createItemSubCategory, updateItemSubCategory, fetchItemSubCategoriesByCategory, fetchItemTags, createItemTag, updateItemTag } from "./inventoryThunk";
// import {  fetchSkuPartySalesAnalytics,  } from "./inventoryThunk";

/**
 * Invoice slice initial state.
 */
const initialState: InventorySliceState = {
    inventories: [],
    rowCount: 0,
    inventoryDeatils: {},
    errorMessage: '',
    isInventoryCreated: false,
    selectedInventoryId: '',
    status: ApiStatus.IDLE,
    // partySalesAnalytics: null,
    categories: [],
    subCategories: [],
    subCategoriesStatus: ApiStatus.IDLE,
    categoriesStatus: ApiStatus.IDLE,
    tags: [],
    tagsStatus: ApiStatus.IDLE,

}

/**
 * Inventory Slice.
 */
const inventorySlice = createSlice({
    name: 'inventory',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch Inventories
            .addCase(fetchInventories.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchInventories.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.inventories = action?.payload.inventories || [];
                state.rowCount = action?.payload?.total || [];
                state.errorMessage = '';
            })

            .addCase(fetchInventories.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Inventory by Account ID
            .addCase(fetchInventoryByAccountId.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchInventoryByAccountId.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.inventories = action?.payload?.inventories || [];
                state.rowCount = action?.payload?.total || [];
                state.errorMessage = '';
            })
            .addCase(fetchInventoryByAccountId.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Inventory by ID
            .addCase(fetchInventoryById.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchInventoryById.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.inventoryDeatils = action?.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchInventoryById.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Add Inventory
            .addCase(addInventory.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(addInventory.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.isInventoryCreated = true;
                state.errorMessage = '';

                toast.success(action.payload.message);
            })
            .addCase(addInventory.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.isInventoryCreated = false;
                state.errorMessage = action.error.message
            })

            // Delete Inventories
            .addCase(deleteInventory.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deleteInventory.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';

                const { id, message } = action.payload;
                state.inventories = state.inventories.filter(item => item._id !== id)

                toast.success(message);
            })
            .addCase(deleteInventory.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message

                toast.success(state.errorMessage);
            })

            // Update Inventory
            .addCase(updateInventory.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(updateInventory.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                const { message, inventory: updateInventory } = action.payload
                state.inventories = state.inventories
                    .map(item => (item._id === item._id ? { ...item, ...updateInventory } : item));

                state.errorMessage = '';

                toast.success(message);
            })
            .addCase(updateInventory.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
            })

            // AdjustStockBySkuId
            .addCase(AdjustStockBySkuId.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(AdjustStockBySkuId.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                const { message, skuHistory: skuHistory } = action.payload
                toast.success(message);
            })
            .addCase(AdjustStockBySkuId.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
            })

            // Create Category
            .addCase(createItemCategory.pending, (state, action) => {
                state.categoriesStatus = ApiStatus.LOADING;
            })
            .addCase(createItemCategory.fulfilled, (state, action) => {
                state.categoriesStatus = ApiStatus.SUCCESS;
                state.categories.push(action.payload);
                state.errorMessage = '';
                toast.success('Category created successfully');
            })
            .addCase(createItemCategory.rejected, (state, action) => {
                state.categoriesStatus = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error('Failed to create category');
            })

            // Update Category
            .addCase(updateItemCategory.pending, (state, action) => {
                state.categoriesStatus = ApiStatus.LOADING;
            })
            .addCase(updateItemCategory.fulfilled, (state, action) => {
                state.categoriesStatus = ApiStatus.SUCCESS;
                state.categories = state.categories.map(cat =>
                    cat._id === action.payload._id ? action.payload : cat
                );
                state.errorMessage = '';
                toast.success('Category updated successfully');
            })
            .addCase(updateItemCategory.rejected, (state, action) => {
                state.categoriesStatus = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error('Failed to update category');

            })

            // Create Sub Category
            .addCase(createItemSubCategory.pending, (state, action) => {
                state.subCategoriesStatus = ApiStatus.LOADING;
            })
            .addCase(createItemSubCategory.fulfilled, (state, action) => {
                state.subCategoriesStatus = ApiStatus.SUCCESS;
                state.subCategories.push(action.payload);
                state.errorMessage = '';
                toast.success('Sub Category created successfully');
            })
            .addCase(createItemSubCategory.rejected, (state, action) => {
                state.subCategoriesStatus = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error('Failed to create sub category');
            })

            // Update Sub Category
            .addCase(updateItemSubCategory.pending, (state, action) => {
                state.subCategoriesStatus = ApiStatus.LOADING;
            })
            .addCase(updateItemSubCategory.fulfilled, (state, action) => {
                state.subCategoriesStatus = ApiStatus.SUCCESS;
                state.subCategories = state.subCategories.map(subCat =>
                    subCat._id === action.payload._id ? action.payload : subCat
                );
                state.errorMessage = '';
                toast.success('Sub Category updated successfully');
            })
            .addCase(updateItemSubCategory.rejected, (state, action) => {
                state.subCategoriesStatus = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error('Failed to update sub category');
            })

            // Fetch Sub Categories
            .addCase(fetchItemSubCategoriesByCategory.pending, (state, action) => {
                state.subCategoriesStatus = ApiStatus.LOADING;
            })
            .addCase(fetchItemSubCategoriesByCategory.fulfilled, (state, action) => {
                state.subCategoriesStatus = ApiStatus.SUCCESS;
                state.subCategories = action.payload;
                state.errorMessage = '';
            })
            .addCase(fetchItemSubCategoriesByCategory.rejected, (state, action) => {
                state.subCategoriesStatus = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
            })

            // Fetch Tags
            .addCase(fetchItemTags.pending, (state, action) => {
                state.tagsStatus = ApiStatus.LOADING;
            })
            .addCase(fetchItemTags.fulfilled, (state, action) => {
                state.tagsStatus = ApiStatus.SUCCESS;
                state.tags = action.payload;
                state.errorMessage = '';
            })
            .addCase(fetchItemTags.rejected, (state, action) => {
                state.tagsStatus = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
            })

            // Create Tag
            .addCase(createItemTag.pending, (state, action) => {
                state.tagsStatus = ApiStatus.LOADING;
            })
            .addCase(createItemTag.fulfilled, (state, action) => {
                state.tagsStatus = ApiStatus.SUCCESS;
                state.tags.push(action.payload);
                state.errorMessage = '';
                toast.success('Tag created successfully');
            })
            .addCase(createItemTag.rejected, (state, action) => {
                state.tagsStatus = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error('Failed to create tag');
            })

            // Update Tag
            .addCase(updateItemTag.pending, (state, action) => {
                state.tagsStatus = ApiStatus.LOADING;
            })
            .addCase(updateItemTag.fulfilled, (state, action) => {
                state.tagsStatus = ApiStatus.SUCCESS;
                state.tags = state.tags.map(tag =>
                    tag._id === action.payload._id ? action.payload : tag
                );
                state.errorMessage = '';
                toast.success('Tag updated successfully');
            })
            .addCase(updateItemTag.rejected, (state, action) => {
                state.tagsStatus = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error('Failed to update tag');
            })

    }
});

export default inventorySlice.reducer;
